
// // import React, { useState, useEffect, useMemo } from 'react';
// // import { Modal, Button, Form, Pagination, InputGroup, Card, Row, Col, Badge, Spinner } from "react-bootstrap"; 
// // import axios from "axios";
// // import config from '../../Common/Configurations/APIConfig';

// // const THEME_COLOR = '#065f46';

// // const daysOfWeekMap = [
// //     { id: 0, name: "Sunday" }, { id: 1, name: "Monday" }, { id: 2, name: "Tuesday" },
// //     { id: 3, name: "Wednesday" }, { id: 4, name: "Thursday" }, { id: 5, name: "Friday" }, { id: 6, name: "Saturday" }
// // ];

// // const initialSalonValues = {
// //     salonId: '00000000-0000-0000-0000-000000000000',
// //     name: '', slug: '', phone: '', email: '', address: '', city: '', password: '', 
// //     status: true
// // };

// // const initialStaffValues = {
// //     staffId: '00000000-0000-0000-0000-000000000000',
// //     salonId: '', name: '', specializations: '', isActive: true
// // };

// // const Salon = () => {
// //     // --- MAIN STATES ---
// //     const [salonLists, setSalonLists] = useState([]);
// //     const [salonLoading, setSalonLoading] = useState(false);
// //     const [pageNumber, setPageNumber] = useState(1);
// //     const [searchTerm, setSearchTerm] = useState("");
    
// //     // --- MODAL STATES ---
// //     const [showSalonModal, setShowSalonModal] = useState(false);
// //     const [salonValues, setSalonValues] = useState(initialSalonValues);
// //     const [showSalonDeleteModal, setShowSalonDeleteModal] = useState(false);
// //     const [salonToDelete, setSalonToDelete] = useState(null);

// //     const [staffLists, setStaffLists] = useState([]);
// //     const [currentSalonForStaff, setCurrentSalonForStaff] = useState(null);
// //     const [showStaffListModal, setShowStaffListModal] = useState(false);
// //     const [showStaffFormModal, setShowStaffFormModal] = useState(false);
// //     const [staffValues, setStaffValues] = useState(initialStaffValues);
// //     const [showStaffDeleteModal, setShowStaffDeleteModal] = useState(false);
// //     const [staffToDelete, setStaffToDelete] = useState(null);

// //     const [showTimingModal, setShowTimingModal] = useState(false);
// //     const [timingValues, setTimingValues] = useState([]);
// //     const [currentSalonForTiming, setCurrentSalonForTiming] = useState(null);
// //     const [timingLoading, setTimingLoading] = useState(false);

// //     // --- APPOINTMENT STATES ---
// //     const [appointmentLists, setAppointmentLists] = useState([]);
// //     const [currentSalonForAppointments, setCurrentSalonForAppointments] = useState(null);
// //     const [showAppointmentListModal, setShowAppointmentListModal] = useState(false);

// //     // --- CUSTOMER DETAIL STATES (NEW) ---
// //     const [showCustomerDetailModal, setShowCustomerDetailModal] = useState(false);
// //     const [selectedCustomer, setSelectedCustomer] = useState(null);

// //     // =========================================================================
// //     // DATA FETCHING
// //     // =========================================================================

// //     const GetSalons = async (pNum) => {
// //         setSalonLoading(true);
// //         try {
// //             const res = await axios.get(config.APIACTIVEURL + config.GETSALONS, { 
// //                 params: { pageSize: 10, pageNumber: pNum } 
// //             });
// //             if (res.data) {
// //                 setSalonLists(res.data.data || []);
// //                 setPageNumber(res.data.pageNumber || 1);
// //             }
// //         } catch (error) {
// //             console.error("Fetch Error", error);
// //         } finally { setSalonLoading(false); }
// //     };

// //     useEffect(() => { GetSalons(pageNumber); }, [pageNumber]);

// //     const filteredSalons = useMemo(() => {
// //         return salonLists.filter(s => 
// //             s.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             s.city?.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //             s.email?.toLowerCase().includes(searchTerm.toLowerCase())
// //         );
// //     }, [salonLists, searchTerm]);

// //     // =========================================================================
// //     // HANDLERS: SALON
// //     // =========================================================================

// //     const handleSalonSubmit = async (e) => {
// //         e.preventDefault();
// //         try {
// //             const isNew = salonValues.salonId === "00000000-0000-0000-0000-000000000000";
// //             const payload = { ...salonValues, status: !!salonValues.status };
// //             if (isNew) await axios.post(config.APIACTIVEURL + config.CREATESALON, payload);
// //             else await axios.put(config.APIACTIVEURL + config.UPDATESALON, payload);
// //             setShowSalonModal(false);
// //             GetSalons(pageNumber);
// //         } catch (error) { alert("Error saving salon. Check required fields."); }
// //     };

// //     const handleSalonDelete = async () => {
// //         try {
// //             await axios.delete(`${config.APIACTIVEURL}${config.DELETESALON}/${salonToDelete}`);
// //             GetSalons(pageNumber);
// //             setShowSalonDeleteModal(false);
// //         } catch (error) { console.error(error); }
// //     };

// //     // =========================================================================
// //     // HANDLERS: STAFF
// //     // =========================================================================

// //     const GetStaffForSalon = async (salonId) => {
// //         try {
// //             const res = await axios.get(config.APIACTIVEURL + config.GETALLSTAFF, { params: { pageSize: 100, pageNumber: 1 } });
// //             const all = Array.isArray(res.data) ? res.data : (res.data.data || []);
// //             setStaffLists(all.filter(s => s.salonId === salonId));
// //         } catch (error) { console.error(error); }
// //     };

// //     const handleStaffSubmit = async (e) => {
// //         e.preventDefault();
// //         try {
// //             const isNew = staffValues.staffId === "00000000-0000-0000-0000-000000000000";
// //             const payload = { ...staffValues, isActive: !!staffValues.isActive };
// //             if (isNew) await axios.post(config.APIACTIVEURL + config.CREATESTAFF, payload);
// //             else await axios.put(config.APIACTIVEURL + config.UPDATESTAFF, payload);
// //             setShowStaffFormModal(false);
// //             GetStaffForSalon(currentSalonForStaff.salonId);
// //         } catch (error) { alert("Staff update failed."); }
// //     };

// //     const handleStaffDelete = async () => {
// //         try {
// //             await axios.delete(`${config.APIACTIVEURL}${config.DELETESTAFF}/${staffToDelete}`);
// //             setShowStaffDeleteModal(false);
// //             GetStaffForSalon(currentSalonForStaff.salonId);
// //         } catch (error) { console.error(error); }
// //     };

// //     // =============================
// //     // HANDLERS: TIMINGS
// //     // =============================

// //     const handleManageTimings = async (salon) => {
// //         setCurrentSalonForTiming(salon);
// //         setTimingLoading(true);
// //         try {
// //             const res = await axios.get(config.APIACTIVEURL + config.GETTIMINGBYSALONID + salon.salonId);
// //             const fullWeekData = daysOfWeekMap.map(day => {
// //                 const found = (res.data || []).find(d => d.dayOfWeek === day.id);
// //                 return found || { timingId: '00000000-0000-0000-0000-000000000000', salonId: salon.salonId, dayOfWeek: day.id, openTime: '09:00', closeTime: '18:00', isClosed: false };
// //             });
// //             setTimingValues(fullWeekData);
// //             setShowTimingModal(true);
// //         } catch (error) { console.error(error); } finally { setTimingLoading(false); }
// //     };

// //     const handleTimingsSave = async () => {
// //         setTimingLoading(true);
// //         try {
// //             for (const item of timingValues) {
// //                 const isNew = item.timingId === "00000000-0000-0000-0000-000000000000";
// //                 await axios({ method: isNew ? 'POST' : 'PUT', url: config.APIACTIVEURL + (isNew ? config.CREATETIMING : config.UPDATETIMING), data: item });
// //             }
// //             setShowTimingModal(false);
// //         } catch (error) { alert("Schedule update failed."); } finally { setTimingLoading(false); }
// //     };

// //     // =============================
// //     // HANDLERS: APPOINTMENTS
// //     // =============================

// //     const GetAppointmentsForSalon = async (salonId) => {
// //         try {
// //             const res = await axios.get(config.APIACTIVEURL + config.GETALLAPPOINTMENTS, { 
// //                 params: { pageSize: 100, pageNumber: 1 } 
// //             });
// //             // Handle both array and paginated response formats
// //             const all = Array.isArray(res.data) ? res.data : (res.data.data || res.data.items || []);
// //             const salonApps = all.filter(a => a.salonId === salonId);
// //             setAppointmentLists(salonApps);
// //         } catch (error) { console.error(error); }
// //     };

// //     const formatDisplayDate = (dateString) => {
// //         if(!dateString) return '-';
// //         return new Date(dateString).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
// //     };

// //     const formatDisplayTime = (dateString) => {
// //         if(!dateString) return '-';
// //         return new Date(dateString).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
// //     };

// //     // =============================
// //     // HANDLERS: CUSTOMER DETAILS (NEW)
// //     // =============================
// //     const handleViewCustomer = (customer) => {
// //         setSelectedCustomer(customer);
// //         setShowCustomerDetailModal(true);
// //     };

// //     return (
// //         <div className="page-content" style={{ paddingTop: "90px", minHeight: '100vh', backgroundColor: '#f8fafc' }}>
// //             <div className="container-fluid px-lg-5 py-4">
                
// //                 {/* HEADER */}
// //                 <Row className="mb-4 g-3 align-items-center">
// //                     <Col md={8}>
// //                         <h3 className="fw-bold text-dark mb-1">Salon Network</h3>
// //                         <p className="text-muted small">Manage branch locations, staff rosters, and hours.</p>
// //                     </Col>
// //                     <Col md={4} className="text-md-end">
// //                         <Button className="shadow-sm border-0 px-4 py-2 fw-bold" style={{ backgroundColor: THEME_COLOR }}
// //                                 onClick={() => { setSalonValues(initialSalonValues); setShowSalonModal(true); }}>
// //                             <i className="ri-add-circle-line me-2"></i> Register New Salon
// //                         </Button>
// //                     </Col>
// //                 </Row>

// //                 {/* MAIN CARD */}
// //                 <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
// //                     <Card.Header className="bg-white border-0 py-4 px-4">
// //                         <Row className="align-items-center">
// //                             <Col md={6}><h5 className="mb-0 fw-bold">Salon Directory</h5></Col>
// //                             <Col md={6}>
// //                                 <InputGroup className="bg-light rounded-3">
// //                                     <InputGroup.Text className="bg-transparent border-0 pe-0"><i className="ri-search-line text-muted"></i></InputGroup.Text>
// //                                     <Form.Control placeholder="Search..." className="bg-transparent border-0 shadow-none py-2" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
// //                                 </InputGroup>
// //                             </Col>
// //                         </Row>
// //                     </Card.Header>

// //                     <div className="table-responsive">
// //                         <table className="table table-hover align-middle mb-0">
// //                             <thead className="table-light text-muted small text-uppercase">
// //                                 <tr><th className="ps-4 py-3">Salon Identity</th><th></th><th>Contact</th><th>Status</th><th className="text-center">Actions</th></tr>
// //                             </thead>
// //                             <tbody>
// //                                 {salonLoading ? (
// //                                     <tr><td colSpan="5" className="text-center py-5"><Spinner animation="border" variant="success" /></td></tr>
// //                                 ) : filteredSalons.map((item) => (
// //                                     <tr key={item.salonId}>
// //                                         <td className="ps-4"><div className="fw-bold text-dark">{item.name}</div><small className="text-muted">{item.slug}</small></td>
// //                                         <td><div className="fw-semibold small">{item.city}</div></td>
// //                                         <td><div className="small fw-semibold">{item.phone}</div><div className="small text-muted">{item.email}</div></td>
// //                                         <td><Badge pill className={item.status ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}>{item.status ? 'Active' : 'Inactive'}</Badge></td>
// //                                         <td className="text-center">
// //                                             <div className="d-flex justify-content-center gap-1">
// //                                                 {/* APPOINTMENT ICON */}
// //                                                 <button className="btn btn-sm btn-light rounded-circle" onClick={() => { setCurrentSalonForAppointments(item); setShowAppointmentListModal(true); GetAppointmentsForSalon(item.salonId); }} title="View Appointments">
// //                                                     <i className="ri-calendar-check-line text-success fs-5"></i>
// //                                                 </button>
                                                
// //                                                 <button className="btn btn-sm btn-light rounded-circle" onClick={() => handleManageTimings(item)}><i className="ri-time-line text-warning fs-5"></i></button>
// //                                                 <button className="btn btn-sm btn-light rounded-circle" onClick={() => { setCurrentSalonForStaff(item); setShowStaffListModal(true); GetStaffForSalon(item.salonId); }}><i className="ri-group-line text-info fs-5"></i></button>
// //                                                 <button className="btn btn-sm btn-light rounded-circle" onClick={() => { setSalonValues(item); setShowSalonModal(true); }}><i className="ri-edit-2-line text-primary fs-5"></i></button>
// //                                                 <button className="btn btn-sm btn-light rounded-circle" onClick={() => { setSalonToDelete(item.salonId); setShowSalonDeleteModal(true); }}><i className="ri-delete-bin-line text-danger fs-5"></i></button>
// //                                             </div>
// //                                         </td>
// //                                     </tr>
// //                                 ))}
// //                             </tbody>
// //                         </table>
// //                     </div>

// //                     <Card.Footer className="bg-white border-0 py-3 d-flex justify-content-between align-items-center px-4">
// //                         <span className="text-muted small">Page <strong>{pageNumber}</strong></span>
// //                         <Pagination className="mb-0">
// //                             <Pagination.Prev disabled={pageNumber === 1} onClick={() => setPageNumber(pageNumber - 1)} />
// //                             <Pagination.Item active>{pageNumber}</Pagination.Item>
// //                             <Pagination.Next onClick={() => setPageNumber(pageNumber + 1)} />
// //                         </Pagination>
// //                     </Card.Footer>
// //                 </Card>

// //                 {/* =======================
// //                     MODAL: SALON FORM
// //                    ======================= */}
// //                 <Modal show={showSalonModal} onHide={() => setShowSalonModal(false)} size="lg" centered backdrop="static" className="fade">
// //                     <Modal.Header closeButton className="border-0 pb-0 ps-4 pt-4">
// //                         <div className="d-flex align-items-center">
// //                             <div className="bg-success-subtle rounded-circle p-2 me-3"><i className="ri-store-2-fill text-success fs-4"></i></div>
// //                             <div>
// //                                 <Modal.Title className="fw-bold fs-5">Salon Profile</Modal.Title>
// //                                 <p className="mb-0 text-muted small">Enter details for the branch location</p>
// //                             </div>
// //                         </div>
// //                     </Modal.Header>
// //                     <Modal.Body className="p-4">
// //                         <Form onSubmit={handleSalonSubmit} className="row g-3">
// //                             <Col md={6}>
// //                                 <Form.Group className="form-floating">
// //                                     <Form.Control type="text" placeholder="Name" value={salonValues.name} onChange={(e) => setSalonValues({...salonValues, name: e.target.value})} required className="border-light-subtle bg-light-subtle fw-bold" />
// //                                     <Form.Label>Salon Name</Form.Label>
// //                                 </Form.Group>
// //                             </Col>
// //                             <Col md={6}>
// //                                 <Form.Group className="form-floating">
// //                                     <Form.Control type="text" placeholder="City" value={salonValues.city} onChange={(e) => setSalonValues({...salonValues, city: e.target.value})} required className="border-light-subtle bg-light-subtle" />
// //                                     <Form.Label>City</Form.Label>
// //                                 </Form.Group>
// //                             </Col>
                            
// //                             <Col md={6}>
// //                                 <Form.Group className="form-floating">
// //                                     <Form.Control type="email" placeholder="Email" value={salonValues.email} onChange={(e) => setSalonValues({...salonValues, email: e.target.value})} required className="border-light-subtle bg-light-subtle" />
// //                                     <Form.Label>Email Address</Form.Label>
// //                                 </Form.Group>
// //                             </Col>
// //                              <Col md={6}>
// //                                 <Form.Group className="form-floating">
// //                                     <Form.Control type="password" placeholder="Password" value={salonValues.password} onChange={(e) => setSalonValues({...salonValues, password: e.target.value})} required className="border-light-subtle bg-light-subtle" />
// //                                     <Form.Label>Access Password</Form.Label>
// //                                 </Form.Group>
// //                             </Col>

// //                             <Col md={6}>
// //                                 <Form.Group className="form-floating">
// //                                     <Form.Control type="text" placeholder="Slug" value={salonValues.slug} onChange={(e) => setSalonValues({...salonValues, slug: e.target.value})} className="border-light-subtle bg-light-subtle" />
// //                                     <Form.Label>URL Slug</Form.Label>
// //                                 </Form.Group>
// //                             </Col>
// //                             <Col md={6}>
// //                                 <Form.Group className="form-floating">
// //                                     <Form.Control type="tel" placeholder="Phone" value={salonValues.phone} onChange={(e) => setSalonValues({...salonValues, phone: e.target.value})} className="border-light-subtle bg-light-subtle" />
// //                                     <Form.Label>Contact Phone</Form.Label>
// //                                 </Form.Group>
// //                             </Col>
                            
// //                             <Col md={12}>
// //                                 <Form.Label className="small fw-bold text-muted ms-1">Full Address</Form.Label>
// //                                 <Form.Control as="textarea" rows={3} value={salonValues.address} onChange={(e) => setSalonValues({...salonValues, address: e.target.value})} className="border-light-subtle bg-light-subtle" />
// //                             </Col>
                            
// //                             <Col md={12} className="d-flex justify-content-between align-items-center mt-4 bg-light p-3 rounded-3">
// //                                 <div><span className="fw-bold text-dark d-block">Public Visibility</span><small className="text-muted">Disable to hide this salon from customer apps.</small></div>
// //                                 <Form.Check type="switch" checked={salonValues.status} onChange={(e) => setSalonValues({...salonValues, status: e.target.checked})} className="fs-4" />
// //                             </Col>
                            
// //                             <Col md={12} className="text-end mt-4 pt-2 border-top">
// //                                 <Button variant="light" onClick={() => setShowSalonModal(false)} className="me-2 px-4 fw-bold">Cancel</Button>
// //                                 <Button type="submit" style={{ backgroundColor: THEME_COLOR }} className="border-0 px-5 fw-bold shadow-sm">Save Salon</Button>
// //                             </Col>
// //                         </Form>
// //                     </Modal.Body>
// //                 </Modal>

// //                 {/* =======================
// //                     MODAL: STAFF LIST
// //                    ======================= */}
// //                 <Modal show={showStaffListModal} onHide={() => setShowStaffListModal(false)} size="lg" centered className="fade">
// //                     <Modal.Header closeButton className="border-0 pb-0 pt-4 ps-4 pe-4">
// //                         <div className="d-flex align-items-center justify-content-between w-100 me-4">
// //                             <div className="d-flex align-items-center">
// //                                 <div className="bg-info-subtle rounded-circle p-2 me-3"><i className="ri-group-fill text-info fs-4"></i></div>
// //                                 <div>
// //                                     <Modal.Title className="fw-bold fs-5">{currentSalonForStaff?.name}</Modal.Title>
// //                                     <p className="mb-0 text-muted small">Staff Roster Management</p>
// //                                 </div>
// //                             </div>
// //                             <Button size="sm" style={{ backgroundColor: THEME_COLOR }} className="border-0 px-3 py-2 shadow-sm fw-bold" 
// //                                 onClick={() => { setStaffValues({ ...initialStaffValues, salonId: currentSalonForStaff.salonId }); setShowStaffFormModal(true); }}>
// //                                 <i className="ri-user-add-line me-1"></i> Add Member
// //                             </Button>
// //                         </div>
// //                     </Modal.Header>
// //                     <Modal.Body className="p-0 mt-3">
// //                         <div className="table-responsive" style={{ maxHeight: '500px' }}>
// //                             <table className="table table-hover align-middle mb-0">
// //                                 <thead className="table-light small uppercase sticky-top">
// //                                     <tr><th className="ps-4 py-3">Professional</th><th>Specialization</th><th>Status</th><th className="text-center">Action</th></tr>
// //                                 </thead>
// //                                 <tbody>
// //                                     {staffLists.length > 0 ? staffLists.map(s => (
// //                                         <tr key={s.staffId}>
// //                                             <td className="ps-4 fw-bold text-dark">{s.name}</td>
// //                                             <td>
// //                                                 <Badge bg="info-subtle" text="info" className="fw-normal border border-info-subtle px-3">
// //                                                     {s.specializations}
// //                                                 </Badge>
// //                                             </td>
// //                                             <td>{s.isActive ? <div className="d-flex align-items-center text-success small fw-bold"><i className="ri-checkbox-circle-fill me-1"></i> Active</div> : <div className="text-muted small"><i className="ri-indeterminate-circle-line me-1"></i> Inactive</div>}</td>
// //                                             <td className="text-center">
// //                                                 <button className="btn btn-sm btn-outline-primary border-0 rounded-circle me-1" onClick={() => { setStaffValues(s); setShowStaffFormModal(true); }}><i className="ri-edit-line fs-5"></i></button>
// //                                                 <button className="btn btn-sm btn-outline-danger border-0 rounded-circle" onClick={() => { setStaffToDelete(s.staffId); setShowStaffDeleteModal(true); }}><i className="ri-delete-bin-line fs-5"></i></button>
// //                                             </td>
// //                                         </tr>
// //                                     )) : (
// //                                         <tr><td colSpan="4" className="text-center py-5 text-muted"><i className="ri-user-unfollow-line fs-1 d-block mb-2 text-light-emphasis"></i>No staff members added yet.</td></tr>
// //                                     )}
// //                                 </tbody>
// //                             </table>
// //                         </div>
// //                     </Modal.Body>
// //                 </Modal>

// //                 {/* =======================
// //                     MODAL: STAFF FORM
// //                    ======================= */}
// //                 <Modal show={showStaffFormModal} onHide={() => setShowStaffFormModal(false)} centered className="fade">
// //                     <Modal.Body className="p-4">
// //                         <div className="text-center mb-4">
// //                             <div className="bg-primary-subtle text-primary rounded-circle d-inline-flex p-3 mb-2"><i className="ri-user-star-line fs-2"></i></div>
// //                             <h5 className="fw-bold">Staff Details</h5>
// //                             <p className="text-muted small">Update professional information</p>
// //                         </div>
// //                         <Form onSubmit={handleStaffSubmit}>
// //                             <Form.Group className="mb-3">
// //                                 <Form.Label className="small fw-bold text-muted">Full Name</Form.Label>
// //                                 <Form.Control type="text" className="bg-light border-0 py-2 fw-semibold" value={staffValues.name} onChange={(e) => setStaffValues({...staffValues, name: e.target.value})} required />
// //                             </Form.Group>
// //                             <Form.Group className="mb-4">
// //                                 <Form.Label className="small fw-bold text-muted">Specialization / Role</Form.Label>
// //                                 <Form.Control type="text" className="bg-light border-0 py-2" value={staffValues.specializations} onChange={(e) => setStaffValues({...staffValues, specializations: e.target.value})} required />
// //                             </Form.Group>
                            
// //                             <div className="d-flex justify-content-between align-items-center mb-4 border rounded-3 p-3">
// //                                 <span className="fw-bold small">Currently Active</span>
// //                                 <Form.Check type="switch" checked={staffValues.isActive} onChange={(e) => setStaffValues({...staffValues, isActive: e.target.checked})} />
// //                             </div>
                            
// //                             <Button type="submit" className="w-100 border-0 py-2 fw-bold shadow-sm" style={{ backgroundColor: THEME_COLOR }}>Save Professional</Button>
// //                         </Form>
// //                     </Modal.Body>
// //                 </Modal>

// //                 {/* =================================
// //                     MODAL: APPOINTMENTS LIST 
// //                    ================================= */}
// //                 <Modal show={showAppointmentListModal} onHide={() => setShowAppointmentListModal(false)} size="xl" centered className="fade">
// //                     <Modal.Header closeButton className="border-0 pb-0 pt-4 ps-4 pe-4">
// //                         <div className="d-flex align-items-center">
// //                             <div className="bg-warning-subtle rounded-circle p-2 me-3"><i className="ri-calendar-event-fill text-warning fs-4"></i></div>
// //                             <div>
// //                                 <Modal.Title className="fw-bold fs-5">Appointment Book</Modal.Title>
// //                                 <p className="mb-0 text-muted small">{currentSalonForAppointments?.name} • <span className="text-success">{appointmentLists.length} Records</span></p>
// //                             </div>
// //                         </div>
// //                     </Modal.Header>
// //                     <Modal.Body className="p-0 mt-3">
// //                         <div className="table-responsive" style={{ maxHeight: '600px', backgroundColor: '#fff' }}>
// //                             <table className="table align-middle mb-0">
// //                                 <thead className="table-light small uppercase sticky-top" style={{zIndex: 5}}>
// //                                     <tr>
// //                                         <th className="ps-4 py-3">Schedule</th>
// //                                         <th>Customer</th>
// //                                         <th>Service</th>
// //                                         <th>Assigned Staff</th>
// //                                         <th>Status</th>
// //                                     </tr>
// //                                 </thead>
// //                                 <tbody>
// //                                     {appointmentLists.length > 0 ? (
// //                                         appointmentLists.map(app => (
// //                                             <tr key={app.appointmentId} className="border-bottom border-light">
// //                                                 <td className="ps-4 py-3">
// //                                                     <div className="d-flex align-items-center">
// //                                                         <div className="bg-light rounded p-2 text-center me-3" style={{minWidth:'50px'}}>
// //                                                             <div className="fw-bold text-dark small">{formatDisplayDate(app.startTime).split(' ')[0]}</div>
// //                                                             <div className="fw-bold text-dark fs-5">{formatDisplayDate(app.startTime).split(' ')[1]}</div>
// //                                                         </div>
// //                                                         <div>
// //                                                             <div className="fw-bold text-dark">{formatDisplayTime(app.startTime)} - {formatDisplayTime(app.endTime)}</div>
// //                                                             <div className="small text-muted">{formatDisplayDate(app.startTime)}</div>
// //                                                         </div>
// //                                                     </div>
// //                                                 </td>
// //                                                 <td>
// //                                                     <div className="d-flex align-items-center justify-content-between pe-3">
// //                                                         {/* FIX: Use app.user to match Identity Backend Model */}
// //                                                         <div>
// //                                                             <div className="fw-bold text-dark">{app.user?.name || app.customerName || <span className="text-muted fst-italic">Unknown</span>}</div>
// //                                                             <div className="text-muted small">{app.user?.email || 'No Email'}</div>
// //                                                         </div>
// //                                                         {/* CUSTOMER DETAILS TRIGGER */}
// //                                                         {app.user && (
// //                                                             <button className="btn btn-sm text-muted rounded-circle bg-light border-0 ms-2" onClick={() => handleViewCustomer(app.user)} title="View Customer Details">
// //                                                                 <i className="ri-more-2-fill fs-5"></i>
// //                                                             </button>
// //                                                         )}
// //                                                     </div>
// //                                                 </td>
// //                                                 <td><Badge bg="light" text="dark" className="border">{app.serviceType?.name || 'N/A'}</Badge></td>
// //                                                 <td><div className="d-flex align-items-center"><i className="ri-user-smile-line me-1 text-muted"></i> {app.staff?.name || 'Unassigned'}</div></td>
// //                                                 <td>
// //                                                     <span className={`badge rounded-pill px-3 py-2 ${app.status === 'Cancelled' ? 'bg-danger-subtle text-danger' : 'bg-success-subtle text-success'}`}>
// //                                                         {app.status || 'Confirmed'}
// //                                                     </span>
// //                                                 </td>
// //                                             </tr>
// //                                         ))
// //                                     ) : (
// //                                         <tr><td colSpan="5" className="text-center py-5">
// //                                             <div className="py-5">
// //                                                 <i className="ri-calendar-2-line fs-1 text-light-emphasis mb-3 d-block"></i>
// //                                                 <h6 className="fw-bold text-muted">No Appointments Found</h6>
// //                                                 <p className="small text-muted">This salon currently has no bookings.</p>
// //                                             </div>
// //                                         </td></tr>
// //                                     )}
// //                                 </tbody>
// //                             </table>
// //                         </div>
// //                     </Modal.Body>
// //                 </Modal>

// //                 {/* =================================
// //                     MODAL: CUSTOMER DETAILS (NEW) 
// //                    ================================= */}
// //                 <Modal show={showCustomerDetailModal} onHide={() => setShowCustomerDetailModal(false)} centered size="sm" className="fade">
// //                     <Modal.Header closeButton className="border-0 pb-0">
// //                         <Modal.Title className="fw-bold fs-6 ms-2">Customer Profile</Modal.Title>
// //                     </Modal.Header>
// //                     <Modal.Body className="p-4 text-center">
// //                         <div className="mb-4">
// //                             <div className="bg-primary-subtle text-primary rounded-circle d-inline-flex justify-content-center align-items-center" style={{ width: '80px', height: '80px' }}>
// //                                 <span className="fs-1 fw-bold">{selectedCustomer?.name?.charAt(0) || 'C'}</span>
// //                             </div>
// //                         </div>
                        
// //                         <h5 className="fw-bold text-dark mb-1">{selectedCustomer?.name || 'Unknown'}</h5>
// //                         <p className="text-muted small mb-4">Registered Customer</p>
                        
// //                         <div className="bg-light rounded-4 p-3 text-start">
// //                             <div className="d-flex align-items-center mb-3">
// //                                 <div className="bg-white p-2 rounded-circle shadow-sm me-3"><i className="ri-mail-line text-primary"></i></div>
// //                                 <div className="overflow-hidden">
// //                                     <span className="d-block small text-muted text-uppercase fw-bold" style={{fontSize: '10px'}}>Email Address</span>
// //                                     <span className="fw-bold text-dark text-truncate d-block">{selectedCustomer?.email || 'N/A'}</span>
// //                                 </div>
// //                             </div>
                            
                            
// //                         </div>

// //                         <Button variant="light" className="w-100 mt-4 fw-bold" onClick={() => setShowCustomerDetailModal(false)}>Close Profile</Button>
// //                     </Modal.Body>
// //                 </Modal>

// //                 {/* =======================
// //                     MODAL: TIMINGS
// //                    ======================= */}
// //                 <Modal show={showTimingModal} onHide={() => setShowTimingModal(false)} size="lg" centered className="fade">
// //                     <Modal.Header closeButton className="border-0 ps-4 pt-4">
// //                         <div className="d-flex align-items-center">
// //                             <div className="bg-secondary-subtle rounded-circle p-2 me-3"><i className="ri-time-fill text-dark fs-4"></i></div>
// //                             <div><Modal.Title className="fw-bold fs-5">Operating Hours</Modal.Title><p className="mb-0 text-muted small">Configure weekly schedule</p></div>
// //                         </div>
// //                     </Modal.Header>
// //                     <Modal.Body className="px-4 pb-4">
// //                         <div className="card border-0 bg-light rounded-4 p-3">
// //                             <table className="table table-borderless align-middle mb-0">
// //                                 <thead className="text-muted small uppercase border-bottom"><tr><th className="pb-3">Day</th><th>Open</th><th>Close</th><th className="text-center">Status</th></tr></thead>
// //                                 <tbody>
// //                                     {timingValues.map((day, index) => (
// //                                         <tr key={index} className={index !== timingValues.length - 1 ? "border-bottom" : ""}>
// //                                             <td className="fw-bold text-dark py-3">{daysOfWeekMap[index].name}</td>
// //                                             <td><Form.Control size="sm" type="time" className="border-0 shadow-sm" value={day.openTime || ''} disabled={day.isClosed} onChange={(e) => { const u = [...timingValues]; u[index].openTime = e.target.value; setTimingValues(u); }} /></td>
// //                                             <td><Form.Control size="sm" type="time" className="border-0 shadow-sm" value={day.closeTime || ''} disabled={day.isClosed} onChange={(e) => { const u = [...timingValues]; u[index].closeTime = e.target.value; setTimingValues(u); }} /></td>
// //                                             <td className="text-center">
// //                                                 <div className="form-check form-switch d-flex justify-content-center">
// //                                                     <input className="form-check-input" type="checkbox" checked={!day.isClosed} onChange={(e) => { const u = [...timingValues]; u[index].isClosed = !e.target.checked; setTimingValues(u); }} style={{cursor:'pointer'}} />
// //                                                 </div>
// //                                             </td>
// //                                         </tr>
// //                                     ))}
// //                                 </tbody>
// //                             </table>
// //                         </div>
// //                         <div className="text-end mt-4">
// //                              <Button variant="light" onClick={() => setShowTimingModal(false)} className="me-2 fw-bold">Discard</Button>
// //                              <Button onClick={handleTimingsSave} style={{ backgroundColor: THEME_COLOR }} className="border-0 px-4 fw-bold shadow-sm">Save Schedule</Button>
// //                         </div>
// //                     </Modal.Body>
// //                 </Modal>

// //                 {/* =======================
// //                     MODAL: DELETE ACTIONS
// //                    ======================= */}
// //                 <Modal show={showSalonDeleteModal} onHide={() => setShowSalonDeleteModal(false)} centered size="sm" className="fade">
// //                     <Modal.Body className="text-center py-5 px-4">
// //                         <div className="bg-danger-subtle text-danger rounded-circle d-inline-flex p-3 mb-3"><i className="ri-alert-fill fs-1"></i></div>
// //                         <h5 className="fw-bold text-dark mb-2">Delete Salon?</h5>
// //                         <p className="text-muted small mb-4">This action cannot be undone. All associated data will be lost.</p>
// //                         <div className="d-grid gap-2">
// //                             <Button variant="danger" className="fw-bold shadow-sm" onClick={handleSalonDelete}>Yes, Delete Permanently</Button>
// //                             <Button variant="light" className="fw-bold" onClick={() => setShowSalonDeleteModal(false)}>Cancel</Button>
// //                         </div>
// //                     </Modal.Body>
// //                 </Modal>

// //                 <Modal show={showStaffDeleteModal} onHide={() => setShowStaffDeleteModal(false)} centered size="sm" className="fade">
// //                     <Modal.Body className="text-center py-5 px-4">
// //                         <div className="bg-warning-subtle text-warning rounded-circle d-inline-flex p-3 mb-3"><i className="ri-user-unfollow-line fs-1"></i></div>
// //                         <h5 className="fw-bold text-dark mb-2">Remove Staff?</h5>
// //                         <p className="text-muted small mb-4">Are you sure you want to remove this professional from the roster?</p>
// //                         <div className="d-grid gap-2">
// //                              <Button variant="danger" className="fw-bold shadow-sm" onClick={handleStaffDelete}>Confirm Removal</Button>
// //                              <Button variant="light" className="fw-bold" onClick={() => setShowStaffDeleteModal(false)}>Cancel</Button>
// //                         </div>
// //                     </Modal.Body>
// //                 </Modal>

// //             </div>
// //         </div>
// //     );
// // };

// // export default Salon;
// //web view 












import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, Form, Pagination, InputGroup, Card, Row, Col, Badge, Spinner } from "react-bootstrap"; 
import axios from "axios";
import config from '../../Common/Configurations/APIConfig';

const THEME_COLOR = '#065f46';

const daysOfWeekMap = [
    { id: 0, name: "Sunday" }, { id: 1, name: "Monday" }, { id: 2, name: "Tuesday" },
    { id: 3, name: "Wednesday" }, { id: 4, name: "Thursday" }, { id: 5, name: "Friday" }, { id: 6, name: "Saturday" }
];

const initialSalonValues = {
    salonId: '00000000-0000-0000-0000-000000000000',
    name: '', slug: '', phone: '', email: '', address: '', city: '', password: '', 
    status: true
};

const initialStaffValues = {
    staffId: '00000000-0000-0000-0000-000000000000',
    salonId: '', name: '', specializations: '', isActive: true
};

const Salon = () => {
    // --- MAIN STATES ---
    const [salonLists, setSalonLists] = useState([]);
    const [salonLoading, setSalonLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    
    // --- MODAL STATES ---
    const [showSalonModal, setShowSalonModal] = useState(false);
    const [salonValues, setSalonValues] = useState(initialSalonValues);
    const [showSalonDeleteModal, setShowSalonDeleteModal] = useState(false);
    const [salonToDelete, setSalonToDelete] = useState(null);

    const [staffLists, setStaffLists] = useState([]);
    const [currentSalonForStaff, setCurrentSalonForStaff] = useState(null);
    const [showStaffListModal, setShowStaffListModal] = useState(false);
    const [showStaffFormModal, setShowStaffFormModal] = useState(false);
    const [staffValues, setStaffValues] = useState(initialStaffValues);
    const [showStaffDeleteModal, setShowStaffDeleteModal] = useState(false);
    const [staffToDelete, setStaffToDelete] = useState(null);

    const [showTimingModal, setShowTimingModal] = useState(false);
    const [timingValues, setTimingValues] = useState([]);
    const [currentSalonForTiming, setCurrentSalonForTiming] = useState(null);
    const [timingLoading, setTimingLoading] = useState(false);

    // --- APPOINTMENT STATES ---
    const [appointmentLists, setAppointmentLists] = useState([]);
    const [currentSalonForAppointments, setCurrentSalonForAppointments] = useState(null);
    const [showAppointmentListModal, setShowAppointmentListModal] = useState(false);

    // --- CUSTOMER DETAIL STATES ---
    const [showCustomerDetailModal, setShowCustomerDetailModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    // =========================================================================
    // DATA FETCHING
    // =========================================================================

    const GetSalons = async (pNum) => {
        setSalonLoading(true);
        try {
            const res = await axios.get(config.APIACTIVEURL + config.GETSALONS, { 
                params: { pageSize: 10, pageNumber: pNum } 
            });
            if (res.data) {
                setSalonLists(res.data.data || []);
                setPageNumber(res.data.pageNumber || 1);
            }
        } catch (error) {
            console.error("Fetch Error", error);
        } finally { setSalonLoading(false); }
    };

    useEffect(() => { GetSalons(pageNumber); }, [pageNumber]);

    const filteredSalons = useMemo(() => {
        return salonLists.filter(s => 
            s.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            s.city?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            s.email?.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [salonLists, searchTerm]);

    // =========================================================================
    // HANDLERS: SALON
    // =========================================================================

    const handleSalonSubmit = async (e) => {
        e.preventDefault();
        try {
            const isNew = salonValues.salonId === "00000000-0000-0000-0000-000000000000";
            const payload = { ...salonValues, status: !!salonValues.status };
            if (isNew) await axios.post(config.APIACTIVEURL + config.CREATESALON, payload);
            else await axios.put(config.APIACTIVEURL + config.UPDATESALON, payload);
            setShowSalonModal(false);
            GetSalons(pageNumber);
        } catch (error) { alert("Error saving salon. Check required fields."); }
    };

    const handleSalonDelete = async () => {
        try {
            await axios.delete(`${config.APIACTIVEURL}${config.DELETESALON}/${salonToDelete}`);
            GetSalons(pageNumber);
            setShowSalonDeleteModal(false);
        } catch (error) { console.error(error); }
    };

    // =========================================================================
    // HANDLERS: STAFF
    // =========================================================================

    const GetStaffForSalon = async (salonId) => {
        try {
            const res = await axios.get(config.APIACTIVEURL + config.GETALLSTAFF, { params: { pageSize: 100, pageNumber: 1 } });
            const all = Array.isArray(res.data) ? res.data : (res.data.data || []);
            setStaffLists(all.filter(s => s.salonId === salonId));
        } catch (error) { console.error(error); }
    };

    const handleStaffSubmit = async (e) => {
        e.preventDefault();
        try {
            const isNew = staffValues.staffId === "00000000-0000-0000-0000-000000000000";
            const payload = { ...staffValues, isActive: !!staffValues.isActive };
            if (isNew) await axios.post(config.APIACTIVEURL + config.CREATESTAFF, payload);
            else await axios.put(config.APIACTIVEURL + config.UPDATESTAFF, payload);
            setShowStaffFormModal(false);
            GetStaffForSalon(currentSalonForStaff.salonId);
        } catch (error) { alert("Staff update failed."); }
    };

    const handleStaffDelete = async () => {
        try {
            await axios.delete(`${config.APIACTIVEURL}${config.DELETESTAFF}/${staffToDelete}`);
            setShowStaffDeleteModal(false);
            GetStaffForSalon(currentSalonForStaff.salonId);
        } catch (error) { console.error(error); }
    };

    // =============================
    // HANDLERS: TIMINGS
    // =============================

    const handleManageTimings = async (salon) => {
        setCurrentSalonForTiming(salon);
        setTimingLoading(true);
        try {
            const res = await axios.get(config.APIACTIVEURL + config.GETTIMINGBYSALONID + salon.salonId);
            const fullWeekData = daysOfWeekMap.map(day => {
                const found = (res.data || []).find(d => d.dayOfWeek === day.id);
                return found || { timingId: '00000000-0000-0000-0000-000000000000', salonId: salon.salonId, dayOfWeek: day.id, openTime: '09:00', closeTime: '18:00', isClosed: false };
            });
            setTimingValues(fullWeekData);
            setShowTimingModal(true);
        } catch (error) { console.error(error); } finally { setTimingLoading(false); }
    };

    const handleTimingsSave = async () => {
        setTimingLoading(true);
        try {
            for (const item of timingValues) {
                const isNew = item.timingId === "00000000-0000-0000-0000-000000000000";
                await axios({ method: isNew ? 'POST' : 'PUT', url: config.APIACTIVEURL + (isNew ? config.CREATETIMING : config.UPDATETIMING), data: item });
            }
            setShowTimingModal(false);
        } catch (error) { alert("Schedule update failed."); } finally { setTimingLoading(false); }
    };

    // =============================
    // HANDLERS: APPOINTMENTS
    // =============================

    const GetAppointmentsForSalon = async (salonId) => {
        try {
            const res = await axios.get(config.APIACTIVEURL + config.GETALLAPPOINTMENTS, { 
                params: { pageSize: 100, pageNumber: 1 } 
            });
            const all = Array.isArray(res.data) ? res.data : (res.data.data || res.data.items || []);
            const salonApps = all.filter(a => a.salonId === salonId);
            setAppointmentLists(salonApps);
        } catch (error) { console.error(error); }
    };

    const formatDisplayDate = (dateString) => {
        if(!dateString) return '-';
        return new Date(dateString).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
    };

    const formatDisplayTime = (dateString) => {
        if(!dateString) return '-';
        return new Date(dateString).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
    };

    const handleViewCustomer = (customer) => {
        setSelectedCustomer(customer);
        setShowCustomerDetailModal(true);
    };

    return (
        <div className="page-content" style={{ paddingTop: "90px", minHeight: '100vh', backgroundColor: '#f8fafc' }}>
            <div className="container-fluid px-lg-5 py-4">
                
                {/* HEADER */}
                <Row className="mb-4 g-3 align-items-center">
                    <Col xs={12} md={8}>
                        <h3 className="fw-bold text-dark mb-1">Salon Network</h3>
                        <p className="text-muted small">Manage branch locations, staff rosters, and hours.</p>
                    </Col>
                    <Col xs={12} md={4} className="text-md-end">
                        <Button className="w-100 w-md-auto shadow-sm border-0 px-4 py-2 fw-bold" style={{ backgroundColor: THEME_COLOR }}
                                onClick={() => { setSalonValues(initialSalonValues); setShowSalonModal(true); }}>
                            <i className="ri-add-circle-line me-2"></i> Register New Salon
                        </Button>
                    </Col>
                </Row>

                {/* MAIN CARD */}
                <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
                    <Card.Header className="bg-white border-0 py-4 px-3 px-md-4">
                        <Row className="align-items-center g-3">
                            <Col xs={12} md={6}><h5 className="mb-0 fw-bold">Salon Directory</h5></Col>
                            <Col xs={12} md={6}>
                                <InputGroup className="bg-light rounded-3">
                                    <InputGroup.Text className="bg-transparent border-0 pe-0"><i className="ri-search-line text-muted"></i></InputGroup.Text>
                                    <Form.Control placeholder="Search..." className="bg-transparent border-0 shadow-none py-2" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                </InputGroup>
                            </Col>
                        </Row>
                    </Card.Header>

                    {/* TABLE: DESKTOP VIEW */}
                    <div className="table-responsive d-none d-md-block">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light text-muted small text-uppercase">
                                <tr><th className="ps-4 py-3">Salon Identity</th><th>Contact</th><th>Status</th><th className="text-center">Actions</th></tr>
                            </thead>
                            <tbody>
                                {salonLoading ? (
                                    <tr><td colSpan="5" className="text-center py-5"><Spinner animation="border" variant="success" /></td></tr>
                                ) : filteredSalons.map((item) => (
                                    <tr key={item.salonId}>
                                        <td className="ps-4"><div className="fw-bold text-dark">{item.name}</div><small className="text-muted">{item.slug}</small></td>
                                        
                                        <td><div className="small fw-semibold">{item.phone}</div><div className="small text-muted">{item.email}</div></td>
                                        <td><Badge pill className={item.status ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}>{item.status ? 'Active' : 'Inactive'}</Badge></td>
                                        <td className="text-center">
                                            <div className="d-flex justify-content-center gap-1">
                                                <button className="btn btn-sm btn-light rounded-circle" onClick={() => { setCurrentSalonForAppointments(item); setShowAppointmentListModal(true); GetAppointmentsForSalon(item.salonId); }} title="View Appointments"><i className="ri-calendar-check-line text-success fs-5"></i></button>
                                                <button className="btn btn-sm btn-light rounded-circle" onClick={() => handleManageTimings(item)} title="Timings"><i className="ri-time-line text-warning fs-5"></i></button>
                                                <button className="btn btn-sm btn-light rounded-circle" onClick={() => { setCurrentSalonForStaff(item); setShowStaffListModal(true); GetStaffForSalon(item.salonId); }} title="Staff"><i className="ri-group-line text-info fs-5"></i></button>
                                                <button className="btn btn-sm btn-light rounded-circle" onClick={() => { setSalonValues(item); setShowSalonModal(true); }} title="Edit"><i className="ri-edit-2-line text-primary fs-5"></i></button>
                                                <button className="btn btn-sm btn-light rounded-circle" onClick={() => { setSalonToDelete(item.salonId); setShowSalonDeleteModal(true); }} title="Delete"><i className="ri-delete-bin-line text-danger fs-5"></i></button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* CARDS: MOBILE VIEW */}
                    <div className="d-md-none p-2">
                        {salonLoading ? (
                            <div className="text-center py-5"><Spinner animation="border" variant="success" /></div>
                        ) : filteredSalons.map((item) => (
                            <Card key={item.salonId} className="mb-3 border rounded-3 shadow-sm">
                                <Card.Body className="p-3">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div>
                                            <h6 className="fw-bold mb-0 text-dark">{item.name}</h6>
                                            <small className="text-muted">{item.city}</small>
                                        </div>
                                        <Badge pill className={item.status ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}>
                                            {item.status ? 'Active' : 'Inactive'}
                                        </Badge>
                                    </div>
                                    <div className="mb-3">
                                        <div className="small text-muted"><i className="ri-phone-line me-1"></i> {item.phone}</div>
                                        <div className="small text-muted"><i className="ri-mail-line me-1"></i> {item.email}</div>
                                    </div>
                                    <div className="d-flex justify-content-between pt-2 border-top gap-2">
                                        <button className="btn btn-sm btn-outline-success flex-grow-1" onClick={() => { setCurrentSalonForAppointments(item); setShowAppointmentListModal(true); GetAppointmentsForSalon(item.salonId); }}><i className="ri-calendar-check-line"></i></button>
                                        <button className="btn btn-sm btn-outline-warning flex-grow-1" onClick={() => handleManageTimings(item)}><i className="ri-time-line"></i></button>
                                        <button className="btn btn-sm btn-outline-info flex-grow-1" onClick={() => { setCurrentSalonForStaff(item); setShowStaffListModal(true); GetStaffForSalon(item.salonId); }}><i className="ri-group-line"></i></button>
                                        <button className="btn btn-sm btn-outline-primary flex-grow-1" onClick={() => { setSalonValues(item); setShowSalonModal(true); }}><i className="ri-edit-2-line"></i></button>
                                        <button className="btn btn-sm btn-outline-danger flex-grow-1" onClick={() => { setSalonToDelete(item.salonId); setShowSalonDeleteModal(true); }}><i className="ri-delete-bin-line"></i></button>
                                    </div>
                                </Card.Body>
                            </Card>
                        ))}
                    </div>

                    <Card.Footer className="bg-white border-0 py-3 d-flex flex-column flex-md-row justify-content-between align-items-center px-4 gap-3">
                        <span className="text-muted small">Page <strong>{pageNumber}</strong></span>
                        <Pagination className="mb-0">
                            <Pagination.Prev disabled={pageNumber === 1} onClick={() => setPageNumber(pageNumber - 1)} />
                            <Pagination.Item active>{pageNumber}</Pagination.Item>
                            <Pagination.Next onClick={() => setPageNumber(pageNumber + 1)} />
                        </Pagination>
                    </Card.Footer>
                </Card>

                {/* MODAL: SALON FORM */}
                <Modal show={showSalonModal} onHide={() => setShowSalonModal(false)} size="lg" centered backdrop="static">
                    <Modal.Header closeButton className="border-0 pb-0 pt-4 px-3 px-md-4">
                        <div className="d-flex align-items-center">
                            <div className="bg-success-subtle rounded-circle p-2 me-3"><i className="ri-store-2-fill text-success fs-4"></i></div>
                            <div>
                                <Modal.Title className="fw-bold fs-5">Salon Profile</Modal.Title>
                                <p className="mb-0 text-muted small d-none d-sm-block">Enter details for the branch location</p>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-3 p-md-4">
                        <Form onSubmit={handleSalonSubmit} className="row g-3">
                            <Col xs={12} md={6}>
                                <Form.Group className="form-floating">
                                    <Form.Control type="text" placeholder="Name" value={salonValues.name} onChange={(e) => setSalonValues({...salonValues, name: e.target.value})} required className="border-light-subtle bg-light-subtle fw-bold" />
                                    <Form.Label>Salon Name</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="form-floating">
                                    <Form.Control type="text" placeholder="City" value={salonValues.city} onChange={(e) => setSalonValues({...salonValues, city: e.target.value})} required className="border-light-subtle bg-light-subtle" />
                                    <Form.Label>City</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="form-floating">
                                    <Form.Control type="email" placeholder="Email" value={salonValues.email} onChange={(e) => setSalonValues({...salonValues, email: e.target.value})} required className="border-light-subtle bg-light-subtle" />
                                    <Form.Label>Email Address</Form.Label>
                                </Form.Group>
                            </Col>
                             <Col xs={12} md={6}>
                                <Form.Group className="form-floating">
                                    <Form.Control type="password" placeholder="Password" value={salonValues.password} onChange={(e) => setSalonValues({...salonValues, password: e.target.value})} required className="border-light-subtle bg-light-subtle" />
                                    <Form.Label>Access Password</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="form-floating">
                                    <Form.Control type="text" placeholder="Slug" value={salonValues.slug} onChange={(e) => setSalonValues({...salonValues, slug: e.target.value})} className="border-light-subtle bg-light-subtle" />
                                    <Form.Label>URL Slug</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group className="form-floating">
                                    <Form.Control type="tel" placeholder="Phone" value={salonValues.phone} onChange={(e) => setSalonValues({...salonValues, phone: e.target.value})} className="border-light-subtle bg-light-subtle" />
                                    <Form.Label>Contact Phone</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Label className="small fw-bold text-muted ms-1">Full Address</Form.Label>
                                <Form.Control as="textarea" rows={3} value={salonValues.address} onChange={(e) => setSalonValues({...salonValues, address: e.target.value})} className="border-light-subtle bg-light-subtle" />
                            </Col>
                            <Col xs={12} className="d-flex justify-content-between align-items-center mt-4 bg-light p-3 rounded-3">
                                <div className="pe-2"><span className="fw-bold text-dark d-block small">Public Visibility</span><small className="text-muted" style={{fontSize: '0.75rem'}}>Disable to hide from customer apps.</small></div>
                                <Form.Check type="switch" checked={salonValues.status} onChange={(e) => setSalonValues({...salonValues, status: e.target.checked})} className="fs-4" />
                            </Col>
                            <Col xs={12} className="text-end mt-4 pt-2 border-top">
                                <Button variant="light" onClick={() => setShowSalonModal(false)} className="me-2 px-4 fw-bold">Cancel</Button>
                                <Button type="submit" style={{ backgroundColor: THEME_COLOR }} className="border-0 px-4 px-md-5 fw-bold shadow-sm">Save Salon</Button>
                            </Col>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* MODAL: STAFF LIST */}
                <Modal show={showStaffListModal} onHide={() => setShowStaffListModal(false)} size="lg" centered>
                    <Modal.Header closeButton className="border-0 pb-0 pt-4 px-3 px-md-4">
                        <div className="d-flex align-items-center justify-content-between w-100 me-3 me-md-4">
                            <div className="d-flex align-items-center">
                                <div className="bg-info-subtle rounded-circle p-2 me-3"><i className="ri-group-fill text-info fs-4"></i></div>
                                <div>
                                    <Modal.Title className="fw-bold fs-5">{currentSalonForStaff?.name}</Modal.Title>
                                    <p className="mb-0 text-muted small d-none d-sm-block">Staff Roster</p>
                                </div>
                            </div>
                            <Button size="sm" style={{ backgroundColor: THEME_COLOR }} className="border-0 px-3 py-2 shadow-sm fw-bold" 
                                onClick={() => { setStaffValues({ ...initialStaffValues, salonId: currentSalonForStaff.salonId }); setShowStaffFormModal(true); }}>
                                <i className="ri-user-add-line me-1"></i> Add
                            </Button>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-0 mt-3">
                        <div className="table-responsive d-none d-md-block" style={{ maxHeight: '500px' }}>
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light small uppercase sticky-top">
                                    <tr><th className="ps-4 py-3">Professional</th><th>Specialization</th><th>Status</th><th className="text-center">Action</th></tr>
                                </thead>
                                <tbody>
                                    {staffLists.length > 0 ? staffLists.map(s => (
                                        <tr key={s.staffId}>
                                            <td className="ps-4 fw-bold text-dark">{s.name}</td>
                                            <td><Badge bg="info-subtle" text="info" className="fw-normal border border-info-subtle px-3">{s.specializations}</Badge></td>
                                            <td>{s.isActive ? <div className="d-flex align-items-center text-success small fw-bold"><i className="ri-checkbox-circle-fill me-1"></i> Active</div> : <div className="text-muted small">Inactive</div>}</td>
                                            <td className="text-center">
                                                <button className="btn btn-sm btn-outline-primary border-0 me-1" onClick={() => { setStaffValues(s); setShowStaffFormModal(true); }}><i className="ri-edit-line fs-5"></i></button>
                                                <button className="btn btn-sm btn-outline-danger border-0" onClick={() => { setStaffToDelete(s.staffId); setShowStaffDeleteModal(true); }}><i className="ri-delete-bin-line fs-5"></i></button>
                                            </td>
                                        </tr>
                                    )) : <tr><td colSpan="4" className="text-center py-5 text-muted">No staff members.</td></tr>}
                                </tbody>
                            </table>
                        </div>
                        {/* Mobile Staff View */}
                        <div className="d-md-none p-3">
                            {staffLists.map(s => (
                                <div key={s.staffId} className="border rounded-3 p-3 mb-2 shadow-sm">
                                    <div className="d-flex justify-content-between">
                                        <div className="fw-bold">{s.name}</div>
                                        <Badge bg={s.isActive ? "success-subtle" : "secondary-subtle"} text={s.isActive ? "success" : "secondary"}>{s.isActive ? 'Active' : 'Inactive'}</Badge>
                                    </div>
                                    <div className="text-muted small mt-1">{s.specializations}</div>
                                    <div className="text-end mt-2">
                                        <Button variant="link" className="p-1 me-2" onClick={() => { setStaffValues(s); setShowStaffFormModal(true); }}><i className="ri-edit-line text-primary"></i></Button>
                                        <Button variant="link" className="p-1" onClick={() => { setStaffToDelete(s.staffId); setShowStaffDeleteModal(true); }}><i className="ri-delete-bin-line text-danger"></i></Button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Modal.Body>
                </Modal>

                {/* MODAL: APPOINTMENTS LIST */}
                <Modal show={showAppointmentListModal} onHide={() => setShowAppointmentListModal(false)} size="xl" centered>
                    <Modal.Header closeButton className="border-0 pb-0 pt-4 px-3 px-md-4">
                        <div className="d-flex align-items-center">
                            <div className="bg-warning-subtle rounded-circle p-2 me-3"><i className="ri-calendar-event-fill text-warning fs-4"></i></div>
                            <div>
                                <Modal.Title className="fw-bold fs-5">Appointment Book</Modal.Title>
                                <p className="mb-0 text-muted small">{currentSalonForAppointments?.name} • <span className="text-success">{appointmentLists.length} Records</span></p>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="p-0 mt-3">
                        <div className="table-responsive d-none d-lg-block" style={{ maxHeight: '600px', backgroundColor: '#fff' }}>
                            <table className="table align-middle mb-0">
                                <thead className="table-light small uppercase sticky-top" style={{zIndex: 5}}>
                                    <tr><th className="ps-4 py-3">Schedule</th><th>Customer</th><th>Service</th><th>Staff</th><th>Status</th></tr>
                                </thead>
                                <tbody>
                                    {appointmentLists.map(app => (
                                        <tr key={app.appointmentId} className="border-bottom border-light">
                                            <td className="ps-4 py-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="bg-light rounded p-2 text-center me-3" style={{minWidth:'50px'}}>
                                                        <div className="fw-bold text-dark small">{formatDisplayDate(app.startTime).split(' ')[0]}</div>
                                                        <div className="fw-bold text-dark fs-5">{formatDisplayDate(app.startTime).split(' ')[1]}</div>
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold text-dark">{formatDisplayTime(app.startTime)} - {formatDisplayTime(app.endTime)}</div>
                                                        <div className="small text-muted">{formatDisplayDate(app.startTime)}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center justify-content-between pe-3">
                                                    <div>
                                                        <div className="fw-bold text-dark">{app.user?.name || app.customerName || 'Unknown'}</div>
                                                        <div className="text-muted small">{app.user?.email || 'No Email'}</div>
                                                    </div>
                                                    {app.user && <button className="btn btn-sm btn-light rounded-circle ms-2" onClick={() => handleViewCustomer(app.user)}><i className="ri-more-2-fill"></i></button>}
                                                </div>
                                            </td>
                                            <td><Badge bg="light" text="dark" className="border">{app.serviceType?.name || 'N/A'}</Badge></td>
                                            <td><div className="small"><i className="ri-user-smile-line me-1 text-muted"></i> {app.staff?.name || 'Unassigned'}</div></td>
                                            <td><Badge pill bg={app.status === 'Cancelled' ? 'danger-subtle' : 'success-subtle'} text={app.status === 'Cancelled' ? 'danger' : 'success'}>{app.status || 'Confirmed'}</Badge></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {/* Mobile Appointments View */}
                        <div className="d-lg-none p-3">
                            {appointmentLists.map(app => (
                                <div key={app.appointmentId} className="card mb-2 border rounded-3 p-3 shadow-sm">
                                    <div className="d-flex justify-content-between mb-2">
                                        <div className="fw-bold text-primary">{formatDisplayTime(app.startTime)}</div>
                                        <Badge pill bg={app.status === 'Cancelled' ? 'danger-subtle' : 'success-subtle'} text={app.status === 'Cancelled' ? 'danger' : 'success'}>{app.status || 'Confirmed'}</Badge>
                                    </div>
                                    <div className="fw-bold mb-1">{app.user?.name || app.customerName}</div>
                                    <div className="small text-muted mb-2">{app.serviceType?.name} • {app.staff?.name}</div>
                                    <div className="small text-muted border-top pt-2"><i className="ri-calendar-line me-1"></i>{formatDisplayDate(app.startTime)}</div>
                                </div>
                            ))}
                        </div>
                    </Modal.Body>
                </Modal>

                {/* MODAL: OPERATING HOURS (TIMINGS) */}
                <Modal show={showTimingModal} onHide={() => setShowTimingModal(false)} size="lg" centered>
                    <Modal.Header closeButton className="border-0 px-3 px-md-4 pt-4">
                        <div className="d-flex align-items-center">
                            <div className="bg-secondary-subtle rounded-circle p-2 me-3"><i className="ri-time-fill text-dark fs-4"></i></div>
                            <div><Modal.Title className="fw-bold fs-5">Operating Hours</Modal.Title><p className="mb-0 text-muted small d-none d-sm-block">Configure weekly schedule</p></div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="px-2 px-md-4 pb-4">
                        <div className="card border-0 bg-light rounded-4 p-2 p-md-3 overflow-hidden">
                            <div className="table-responsive">
                                <table className="table table-borderless align-middle mb-0">
                                    <thead className="text-muted small uppercase border-bottom"><tr><th className="pb-3">Day</th><th>Open</th><th>Close</th><th className="text-center">Status</th></tr></thead>
                                    <tbody>
                                        {timingValues.map((day, index) => (
                                            <tr key={index} className={index !== timingValues.length - 1 ? "border-bottom" : ""}>
                                                <td className="fw-bold text-dark py-3" style={{fontSize: '0.85rem'}}>{daysOfWeekMap[index].name}</td>
                                                <td><Form.Control size="sm" type="time" className="border-0 shadow-sm" value={day.openTime || ''} disabled={day.isClosed} onChange={(e) => { const u = [...timingValues]; u[index].openTime = e.target.value; setTimingValues(u); }} /></td>
                                                <td><Form.Control size="sm" type="time" className="border-0 shadow-sm" value={day.closeTime || ''} disabled={day.isClosed} onChange={(e) => { const u = [...timingValues]; u[index].closeTime = e.target.value; setTimingValues(u); }} /></td>
                                                <td className="text-center">
                                                    <div className="form-check form-switch d-flex justify-content-center">
                                                        <input className="form-check-input" type="checkbox" checked={!day.isClosed} onChange={(e) => { const u = [...timingValues]; u[index].isClosed = !e.target.checked; setTimingValues(u); }} />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="text-end mt-4">
                             <Button variant="light" onClick={() => setShowTimingModal(false)} className="me-2 fw-bold">Discard</Button>
                             <Button onClick={handleTimingsSave} style={{ backgroundColor: THEME_COLOR }} className="border-0 px-4 fw-bold shadow-sm">Save Schedule</Button>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* MODAL: DELETE CONFIRMATIONS, CUSTOMER DETAILS (STAFF FORM) MODALS (OMITTED FOR BREVITY - ALREADY IN LOGIC) */}
                <Modal show={showStaffFormModal} onHide={() => setShowStaffFormModal(false)} centered>
                    <Modal.Body className="p-4">
                        <div className="text-center mb-4">
                            <div className="bg-primary-subtle text-primary rounded-circle d-inline-flex p-3 mb-2"><i className="ri-user-star-line fs-2"></i></div>
                            <h5 className="fw-bold">Staff Details</h5>
                        </div>
                        <Form onSubmit={handleStaffSubmit}>
                            <Form.Group className="mb-3"><Form.Label className="small fw-bold text-muted">Full Name</Form.Label><Form.Control type="text" className="bg-light border-0 py-2 fw-semibold" value={staffValues.name} onChange={(e) => setStaffValues({...staffValues, name: e.target.value})} required /></Form.Group>
                            <Form.Group className="mb-4"><Form.Label className="small fw-bold text-muted">Specialization</Form.Label><Form.Control type="text" className="bg-light border-0 py-2" value={staffValues.specializations} onChange={(e) => setStaffValues({...staffValues, specializations: e.target.value})} required /></Form.Group>
                            <div className="d-flex justify-content-between align-items-center mb-4 border rounded-3 p-3">
                                <span className="fw-bold small">Currently Active</span>
                                <Form.Check type="switch" checked={staffValues.isActive} onChange={(e) => setStaffValues({...staffValues, isActive: e.target.checked})} />
                            </div>
                            <Button type="submit" className="w-100 border-0 py-2 fw-bold shadow-sm" style={{ backgroundColor: THEME_COLOR }}>Save Professional</Button>
                        </Form>
                    </Modal.Body>
                </Modal>

                <Modal show={showCustomerDetailModal} onHide={() => setShowCustomerDetailModal(false)} centered size="sm">
                    <Modal.Header closeButton className="border-0 pb-0"><Modal.Title className="fw-bold fs-6 ms-2">Customer Profile</Modal.Title></Modal.Header>
                    <Modal.Body className="p-4 text-center">
                        <div className="mb-4"><div className="bg-primary-subtle text-primary rounded-circle d-inline-flex justify-content-center align-items-center" style={{ width: '80px', height: '80px' }}><span className="fs-1 fw-bold">{selectedCustomer?.name?.charAt(0) || 'C'}</span></div></div>
                        <h5 className="fw-bold text-dark mb-1">{selectedCustomer?.name || 'Unknown'}</h5>
                        <p className="text-muted small mb-4">{selectedCustomer?.email}</p>
                        <Button variant="light" className="w-100 fw-bold" onClick={() => setShowCustomerDetailModal(false)}>Close</Button>
                    </Modal.Body>
                </Modal>

                <Modal show={showSalonDeleteModal} onHide={() => setShowSalonDeleteModal(false)} centered size="sm">
                    <Modal.Body className="text-center py-5 px-4">
                        <div className="bg-danger-subtle text-danger rounded-circle d-inline-flex p-3 mb-3"><i className="ri-alert-fill fs-1"></i></div>
                        <h5 className="fw-bold text-dark mb-2">Delete Salon?</h5>
                        <div className="d-grid gap-2 mt-4">
                            <Button variant="danger" className="fw-bold" onClick={handleSalonDelete}>Yes, Delete</Button>
                            <Button variant="light" className="fw-bold" onClick={() => setShowSalonDeleteModal(false)}>Cancel</Button>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showStaffDeleteModal} onHide={() => setShowStaffDeleteModal(false)} centered size="sm">
                    <Modal.Body className="text-center py-5 px-4">
                        <div className="bg-warning-subtle text-warning rounded-circle d-inline-flex p-3 mb-3"><i className="ri-user-unfollow-line fs-1"></i></div>
                        <h5 className="fw-bold text-dark mb-2">Remove Staff?</h5>
                        <div className="d-grid gap-2 mt-4">
                             <Button variant="danger" className="fw-bold" onClick={handleStaffDelete}>Remove</Button>
                             <Button variant="light" className="fw-bold" onClick={() => setShowStaffDeleteModal(false)}>Cancel</Button>
                        </div>
                    </Modal.Body>
                </Modal>

            </div>
        </div>
    );
};

export default Salon;